import { DialogType } from '@/enums/dialogType'
import { OperationType } from '@/enums/operationType'
import api from '@/services/api'

export default {
    namespaced: true,
    state: {
        order: {},
        lstOrder: [],
        lstOrderItems: [],
        isUpdate: false,
        shouldReload: false,
        search: "",
        itemsPerPage: 25,
        hasNext: false,
        page: 1,
        totalItems: 0,
        headers: [
            { title: 'Venda', key: 'orderId', align: 'center' },
            { title: 'Cliente', key: 'customerName', align: 'center' },
            { title: 'Estoque', key: 'stockName', align: 'center' },
            { title: 'Data', key: 'orderDate', align: 'center' },
            { title: 'Operação', key: 'operation', align: 'center' },
        ],
        headersItems: [
            { title: 'ID Produto', key: 'productId', align: 'center' },
            { title: 'Produto', key: 'productName', align: 'center' },
            { title: 'Quantidade', key: 'quantity', align: 'center' },
            { title: 'Preço', key: 'unitPrice', align: 'center' },
            { title: '', key: 'actions', align: 'center' }
        ],
    },
    getters: {
        getOrder(state) {
            let order = { ...state.order, orderItems: state.lstOrderItems }
            return order
        }
    },
    mutations: {
        setOrder(state, order) {
            state.order = order
        },
        setLstOrder(state, lstOrder) {
            state.lstOrder = lstOrder
        },
        setLstOrderItems(state, lstOrderItems) {
            state.lstOrderItems = lstOrderItems
        },
        appendLstOrder(state, items) {
            state.lstOrder = [...state.lstOrder, ...items]
        },
        clearLstOrder(state) {
            state.lstOrder = []
        },
        setPage(state, page) {
            state.page = page
        },
        setHasNext(state, hasNext) {
            state.hasNext = hasNext
        },
        setTotalItems(state, total) {
            state.totalItems = total
        },
        setShouldReload(state, reload) {
            state.shouldReload = reload
        },
        initForm(state) {
            state.isUpdate = false
            state.order = { ...this.order, operation: OperationType.Venda }
            state.lstOrderItems = []
            state.search = ''
        },
        setUpdating(state) {
            state.isUpdate = true
        },
        setTotalValue(state, value) {
            state.order.totalValue = value
        }
    },
    actions: {
        async save({ state, dispatch }) {
            if (state.isUpdate) {
                return await dispatch('update')
            }
            else
                return await dispatch('insert')
        },

        async insert({ getters, dispatch }) {
            await api.post(
                '/Orders/Insert',
                getters.getOrder
            )

            dispatch('systemDialog/show', {
                type: DialogType.SUCCESS,
                message: 'Pedido salvo'
            }, { root: true })

            return true
        },

        async update({ getters, dispatch }) {
            await api.put(
                '/Orders/Update',
                getters.getOrder
            )

            dispatch('systemDialog/show', {
                type: DialogType.SUCCESS,
                message: 'Pedido atualizado'
            }, { root: true })

            return true
        },

        async search({ state, commit }, { search, limit = 25, page = 1, reset}) {
            let searchParam = search || state.search
            const response = await api.get(
                `/Orders/Search?search=${searchParam}&limit=${limit}&page=${page}`
            )

            if (reset) {
                commit("setLstOrder", response.data.items)
            } else {
                commit("appendLstOrder", response.data.items)
            }

            commit('setHasNext', response.data.hasNext)
            commit('setTotalItems', response.data.totalCount)
            commit('setPage', page)

            return true
        },

        async find({commit}, orderId) {
            const response = await api.get(
                `/Orders/Find/${orderId}`,
            )
            commit('setOrder', response.data)
            commit('setUpdating')

            return true
        },

        async findList({commit}, orderId) {
            const response = await api.get(
                `/Orders/FindList/${orderId}`,
            )
            commit('setLstOrderItems', response.data)

            return true
        },

        async delete({ getters, dispatch }) {
            await api.delete(
                `/Orders/Delete/${getters.getOrder.orderId}`,
            )
            dispatch('systemDialog/show', {
                type: DialogType.SUCCESS,
                message: 'Registro deletado com sucesso!'
            }, { root: true })

            return true
        }
    }
}